export default "__VITE_ASSET__BAEgzW8W__"